import * as React from "react";
import './Pick.css';
import '../../components/Typograph.css';
import AppHeader from '../../components/AppHeader';
import AppFooter from "../../components/AppFooter";
import ImageRadioPicker from "../../components/ImageRadioPicker";
import {BeslagType} from "../../Model";
import oudhollandsImage from '../../images/beslag/oudhollands.jpg'
import traditioneelImage from '../../images/beslag/traditioneel.jpg'
import otherImage from '../../images/template/other1.png'
import PropTypes from "prop-types";

VersionPick.propTypes = {
    handleNextPage: PropTypes.func.isRequired,
    handlePreviousPage: PropTypes.func.isRequired,
    handlePageChange: PropTypes.func.isRequired,
    allValues: PropTypes.object.isRequired,
}

export default function VersionPick(props) {
    const currentValue = props.allValues.VersionPick;

    return (
        <div className="page">
            <AppHeader title="Beslag uitvoering"/>

            <div className="page-middle">
                <h1 className="pick-title">Welk beslagtype heeft u nodig?</h1>

                <div className="pick-body">
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={BeslagType.OUDHOLLANDS}
                                      image={oudhollandsImage}/>

                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={BeslagType.TRADITIONEEL}
                                      image={traditioneelImage}/>

                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={{value: BeslagType.OTHER, text: ""}}
                                      child
                                      image={otherImage}/>
                </div>
            </div>
            <AppFooter onNext={props.handleNextPage}
                       onPrevious={props.handlePreviousPage}
                       enableNext={currentValue}/>
        </div>
    );
}
